var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired7c6"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired7c6"] = parcelRequire;
}
parcelRequire("faBfA");
parcelRequire("h5Hr7");
parcelRequire("bUb57");
parcelRequire("aqXyV");

var $9MaFa = parcelRequire("9MaFa");

var $7274P = parcelRequire("7274P");

var $bEw54 = parcelRequire("bEw54");
parcelRequire("I2Abx");

var $38Z3Q = parcelRequire("38Z3Q");
//import getGenres from './get-genres';
const $c10c282de78da56f$var$myService = new (0, $9MaFa.default)();
const $c10c282de78da56f$var$weeklyGallery = document.querySelector(".weekly-gallery");
$c10c282de78da56f$var$weeklyGallery.addEventListener("click", $c10c282de78da56f$var$hendlerOpenModalWindow);
function $c10c282de78da56f$var$hendlerOpenModalWindow(evt) {
    const el = evt.target.closest("[film-id]");
    if (el) (0, $38Z3Q.openModalCard)(el.getAttribute("film-id"));
}
$c10c282de78da56f$var$renderGalleryWeekly();
function $c10c282de78da56f$var$renderGalleryWeekly() {
    $c10c282de78da56f$var$myService.fetchTrendingWeekMovies().then((resp)=>{
        const movies = resp.data.results;
        const indexes = $c10c282de78da56f$var$rendomIndx(movies.length - 1);
        const weeklyMovies = [];
        indexes.forEach((index)=>{
            const movie = movies[index];
            weeklyMovies.push(movie);
        });
        function createMarkup(arr) {
            return weeklyMovies.map((a)=>(0, $7274P.default)(a, (0, $bEw54.default))).join("");
        }
        $c10c282de78da56f$var$weeklyGallery.innerHTML = createMarkup(weeklyMovies);
    }).catch((e)=>console.error(e));
}
function $c10c282de78da56f$var$rendomIndx(x) {
    const moviesIndx = [];
    while(moviesIndx.length < 3){
        const num = Math.floor(Math.random() * x);
        if (moviesIndx.includes(num)) continue;
        else moviesIndx.push(num);
    }
    return moviesIndx;
}



var $9MaFa = parcelRequire("9MaFa");

var $b5rV1 = parcelRequire("b5rV1");

var $2rpgd = parcelRequire("2rpgd");
function $c2ebf57edb8fe910$export$2e2bcd8739ae039(array) {
    const randomIndex = Math.floor(Math.random() * 15);
    const randomMovie = array.filter((movie)=>movie.backdrop_path !== null).map((movie)=>{
        const movieMarkup = `
                <div class="upcoming-left-wrap">
                    <div class="up-thumb">
                        <img
                            srcset="
                                https://image.tmdb.org/t/p/w300/${movie.backdrop_path}      300w,
                                https://image.tmdb.org/t/p/w780/${movie.backdrop_path}      780w,
                                https://image.tmdb.org/t/p/w1280/${movie.backdrop_path}      1280w,
                                https://image.tmdb.org/t/p/original/${movie.backdrop_path}  3840w
                            "
                            sizes="(min-width: 320px) 498px,
                                    (min-width: 768px) 704px,
                                    (min-width: 1280px) 805px,
                                    100vw"
                            src="https://image.tmdb.org/t/p/w300/${movie.backdrop_path}"
                            alt="${movie.title}"
                            class="upcoming-image"
                            width="1280"
                            height="720"
                        />
                    </div>
                </div>
                <div class="upcoming-right-wrap">
                    <h2 class="upcoming-movie-title">${movie.title}</h2>
                    <table class="upcoming-table">
                        <tr class="upcoming-tab-row">
                            <td class="upcoming-data">Release date</td>
                            <td class="upcom-data-release">${movie.release_date}</td>
                        </tr>
                        <tr class="upcoming-tab-row">
                            <td class="upcoming-data">Vote / Votes</td>
                            <td class="upcoming-data-average">
                                <span class="up-average">${movie.vote_average}</span>/<span class="up-count">${movie.vote_count}</span>
                            </td>
                        </tr>
                        <tr class="upcoming-tab-row">
                            <td class="upcoming-data">Popularity</td>
                            <td class="upcoming-data-get">${movie.popularity.toFixed(1)}</td>
                        </tr>
                        <tr class="upcoming-tab-row">
                            <td class="upcoming-data">Genre</td>
                            <td class="upcoming-data-get">${(0, $2rpgd.default)().filter(({ id: id  })=>movie.genre_ids.includes(id)).map(({ name: name  })=>name).slice(0, 2).join(", ")}</td>
                        </tr>
                    </table>
                    <p class="upcoming-about">About</p>
                    <p class="upcoming-about-descr">${movie.overview}</p>
                    <div class="up-wrap-btn">
                        <button type="button" class="up-btn" data-movie-id="${movie.id}">Add to my library</button>
                    </div>
                </div>`;
        return {
            id: movie.id,
            markup: movieMarkup
        };
    })[randomIndex];
    return randomMovie;
}


const $65414923e0a79c46$var$wrapperForRender = document.querySelector(".js-upcoming-wrapper");
const $65414923e0a79c46$var$serviceUpcoming = new (0, $9MaFa.default)();
$65414923e0a79c46$var$serviceShowUpcoming();
async function $65414923e0a79c46$var$serviceShowUpcoming() {
    try {
        const resp = await $65414923e0a79c46$var$serviceUpcoming.fetchUpcomingMovies();
        const data = resp.data;
        const arrayResults = data.results; //array with results
        if (arrayResults.length > 0) {
            const upcomingFilm = await (0, $c2ebf57edb8fe910$export$2e2bcd8739ae039)(arrayResults);
            const { id: id , markup: markup  } = upcomingFilm;
            $65414923e0a79c46$var$wrapperForRender.innerHTML = markup;
            const btnSaveToLocalStorage = document.querySelector(".up-btn");
            (0, $b5rV1.isInLibrary)(id) ? btnSaveToLocalStorage.textContent = "Remove from my library" : btnSaveToLocalStorage.textContent = "Add to my library";
            //event
            $65414923e0a79c46$var$wrapperForRender.addEventListener("click", (e)=>{
                if (e.target === document.querySelector(".up-btn")) {
                    const button = e.target;
                    const movieId = e.target.dataset.movieId;
                    const getMovie = arrayResults.find((movie)=>movie.id == movieId);
                    if ((0, $b5rV1.isInLibrary)(movieId)) {
                        (0, $b5rV1.removeFromLibrary)(movieId);
                        button.textContent = "Add to my library";
                    } else {
                        (0, $b5rV1.saveToLibrary)(getMovie);
                        button.textContent = "Remove from my library";
                    }
                }
            });
        } else if (arrayResults.length === 0) $65414923e0a79c46$var$wrapperForRender.innerHTML = '<p class="upcoming-error">OOPS... We are very sorry! Upcoming this month not found.</p>';
    } catch (e) {
        console.error(e);
    }
}


parcelRequire("38Z3Q");
parcelRequire("I2Abx");
parcelRequire("6fsAg");
parcelRequire("epHO8");


//# sourceMappingURL=index.8d03b0ec.js.map
